import _ from 'lodash';
import React, { Component } from 'react';
import ProductItem from './product-item';
import AddToCard from './add-to-cart';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';

class SearchPagePreview extends Component<ComposedProps, State> {
  state = {
    selectedProducts: {}
  };

  componentDidMount() {
    const { widget } = this.props;
    const { bundleProducts } = widget;
    this.buildProductOptions(bundleProducts);
  }

  componentWillReceiveProps(nextProps) {
    const { bundleProducts } = this.props.widget;
    const { bundleProducts: nextBundleProducts } = nextProps.widget;
    if (_.difference(bundleProducts, nextBundleProducts)) {
      this.buildProductOptions(nextBundleProducts);
    }
  }

  buildProductOptions(products) {
    if (products && products.length > 0) {
      const selectedProducts = {};
      products.forEach(product => {
        selectedProducts[product.id] = {
          selected: true,
          price:
            product.variants && product.variants[0] && product.variants[0].price
              ? product.variants[0].price
              : product.price
        };
      });
      this.setState({ selectedProducts });
    }
  }

  updateSelectedProduct = (id, selectedProducts, selected) => {
    selectedProducts[id].selected = selected;
    this.setState({ selectedProducts });
  };

  splitFontStyle(fontStyle) {
    if (!fontStyle) {
      return {
        fontWeight: 100,
        fontStyle: 'normal'
      };
    }
    if (fontStyle === 'regular') {
      return {
        fontWeight: 400,
        fontStyle: 'normal'
      };
    }
    const fontWeight = fontStyle.match(/\d+/);
    const fontStyleValue = fontStyle.replace(/\d+/g, '').trim();
    return {
      fontWeight: fontWeight ? fontWeight[0] : 100,
      fontStyle: fontStyleValue || 'normal'
    };
  }

  render() {
    const { formValues, tenantApp, widget } = this.props;
    const {
      titleName,
      titleAlignment,
      titleFont,
      titleFontSize,
      titleFontStyle,
      titleTextColor,
      titleTextTransform,
      buttonText,
      buttonBackgroundColor,
      buttonTextColor
    } = formValues;
    const { bundleProducts } = widget;
    const fontStyleValue = this.splitFontStyle(titleFontStyle);
    const titleStyle = {
      fontFamily: titleFont,
      fontSize: titleFontSize,
      color: titleTextColor,
      textTransform: titleTextTransform,
      textSizeAdjust: '100%',
      textRendering: 'optimizeLegibility',
      boxSizing: 'border-box',
      maxWidth: 'calc(100% - 60px)',
      flex: '0 0 auto',
      wordBreak: 'break-word',
      textAlign: titleAlignment,
      ...fontStyleValue
    };
    const buttonStyle = {
      backgroundColor: buttonBackgroundColor,
      color: buttonTextColor
    };
    const numberOfProduct = bundleProducts.length;

    return (
      <div className="bundle-preview_search-page">
        <div className={`recommendation-title${titleAlignment === 'left' ? '-left' : ''}`}>
          <span
            className={`recommendation-title-text${titleAlignment === 'left' ? '-left' : ''}`}
            style={titleStyle}>
            {titleName}
          </span>
        </div>
        <div className="recommendation-bundle-body">
          <div className="product-items">
            <div className="product-items-wrapper">
              <div
                className="product-image-card"
                style={{
                  width: `calc(100%/5 * ${numberOfProduct})`
                }}>
                {bundleProducts.map((product, index) => (
                  <ProductItem
                    page="search-page"
                    key={product.id}
                    product={product}
                    numberOfProduct={numberOfProduct}
                    index={index}
                    selectedProducts={this.state.selectedProducts}
                    updateSelectedProduct={this.updateSelectedProduct}
                    tenantApp={tenantApp}
                  />
                ))}
              </div>
              <AddToCard
                numberOfProduct={numberOfProduct}
                selectedProducts={this.state.selectedProducts}
                tenantApp={tenantApp}
                buttonText={buttonText}
                buttonStyle={buttonStyle}
                widget={widget}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch, ownProps) => ({});
const mapStateToProps = (state, props) => {
  return {
    tenantApp: _.get(state.oauth, 'tenantApp', {})
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(SearchPagePreview));
